import React from 'react'
import PropTypes from 'prop-types'
import { Container, Row, Col } from 'reactstrap'
import { Grid, Box } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import DayPicker from 'react-day-picker'
import moment from 'moment'
import 'moment-timezone'

import TrendingTableComponent from './TrendingTableComponent'
import '../calendar/CalendarComponent.scss'
import './TrendingComponent.scss'
import { TRENDING_TOPICS_INSTAGRAM, TRENDING_TOPICS_TIKTOK, TRENDING_TOPICS_TWITTER, TRENDING_TOPICS_YOUTUBE } from '../../constants/commons'

export default class TrendingComponent extends React.Component {
  static propTypes = {
    twitterTrends: PropTypes.object,
    youtubeTrends: PropTypes.object,
    tikTokTrends: PropTypes.object,
    instagramTrends: PropTypes.object,
    trendingDate: PropTypes.object,
    trendingTopicsExport: PropTypes.object,
    setSelectedTrendDate: PropTypes.func.isRequired,
    fetchTrendingTopicsYoutube: PropTypes.func.isRequired,
    fetchTrendingTopicsTwitter: PropTypes.func.isRequired,
    fetchTrendingTopicsTikTok: PropTypes.func.isRequired,
    fetchTrendingTopicsInstagram: PropTypes.func.isRequired,
    fetchTrendingTopicsDate: PropTypes.func.isRequired,
    fetchTrendingTopicsExport: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)
    this.state = {
      selectedDay: moment().subtract(1, 'day').toDate(),
      twitterTrends: [],
      youtubeTrends: [],
      tikTokTrends: [],
      instagramTrends: [],
      twitterTrendingDate: null,
      youtubeTrendingDate: null,
      tikTokTrendingDate: null,
      instagramTrendingDate: null,
      isCalendarOpen: false,
      globalSearchText: '',
      exportCompleted: false
    }
    this.calendarRef = React.createRef()
    this.buttonRef = React.createRef()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.twitterTrends !== this.props.twitterTrends && this.props.twitterTrends.details) {
      this.setState({ twitterTrends: this.props.twitterTrends })
    }
    if (prevProps.youtubeTrends !== this.props.youtubeTrends && this.props.youtubeTrends.details) {
      this.setState({ youtubeTrends: this.props.youtubeTrends })
    }
    if (prevProps.tikTokTrends !== this.props.tikTokTrends && this.props.tikTokTrends.details) {
      this.setState({ tikTokTrends: this.props.tikTokTrends })
    }
    if (prevProps.instagramTrends !== this.props.instagramTrends && this.props.instagramTrends.details) {
      this.setState({ instagramTrends: this.props.instagramTrends })
    }
    if (prevProps.trendingDate !== this.props.trendingDate && this.props.trendingDate.details && this.props.trendingDate.details) {
      this.setState({
        twitterTrendingDate: this.props.trendingDate.details.filter(e => e.platform === TRENDING_TOPICS_TWITTER)[0].max_date,
        youtubeTrendingDate: this.props.trendingDate.details.filter(e => e.platform === TRENDING_TOPICS_YOUTUBE)[0].max_date,
        tikTokTrendingDate: this.props.trendingDate.details.filter(e => e.platform === TRENDING_TOPICS_TIKTOK)[0].max_date,
        instagramTrendingDate: this.props.trendingDate.details.filter(e => e.platform === TRENDING_TOPICS_INSTAGRAM)[0].max_date
      })
    }
    if (this.props.trendingTopicsExport && !this.props.trendingTopicsExport.isFetching && prevProps.trendingTopicsExport.isFetching !== this.props.trendingTopicsExport.isFetching) {
      this.setState({ exportCompleted: true })
      setTimeout(() => {
        this.setState({ exportCompleted: false })
      }, 3000)
    }
  }

  handleDayClick = day => {
    let formattedDate = moment(day).format('YYYY-MM-DD')
    this.setState({ selectedDay: day, isCalendarOpen: false, globalSearchText: '' })
    this.props.setSelectedTrendDate(formattedDate)
    this.props.fetchTrendingTopicsTwitter(formattedDate)
    this.props.fetchTrendingTopicsYoutube(formattedDate)
    this.props.fetchTrendingTopicsTikTok(formattedDate)
    this.props.fetchTrendingTopicsInstagram(formattedDate)
    this.props.fetchTrendingTopicsDate(formattedDate)
  }

  toggleCalendar = () => {
    this.setState(prevState => ({ isCalendarOpen: !prevState.isCalendarOpen }))
  }

  formatDateForButton = (date) => {
    if (!date) return moment().format('MMM DD, YYYY')
    return moment(date).format('MMM DD, YYYY')
  }

  componentDidMount () {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount () {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }
  handleClickOutside = (event) => {
    if (
      this.state.isCalendarOpen &&
      this.calendarRef &&
      this.calendarRef.current &&
      !this.calendarRef.current.contains(event.target) &&
      this.buttonRef &&
      this.buttonRef.current &&
      !this.buttonRef.current.contains(event.target)
    ) {
      this.setState({ isCalendarOpen: false })
    }
  }

  handleGlobalSearchChange = (e) => {
    this.setState({ globalSearchText: e.target.value })
  }

  handleExportClick = () => {
    const formattedDate = moment(this.state.selectedDay).format('YYYY-MM-DD')
    this.props.fetchTrendingTopicsExport(formattedDate)
  }

  render () {
    const TRENDING_SECTIONS = [
      { id: TRENDING_TOPICS_TWITTER, title: 'X (Twitter) Trends', description: 'Trending topics for X (Twitter) on selected day.', rows: this.state.twitterTrends?.details, trendingDate: this.state.twitterTrendingDate },
      { id: TRENDING_TOPICS_YOUTUBE, title: 'YouTube Trends', description: 'Trending topics for YouTube on selected day.', rows: this.state.youtubeTrends?.details, trendingDate: this.state.youtubeTrendingDate },
      { id: TRENDING_TOPICS_TIKTOK, title: 'TikTok Trends', description: 'Trending topics for TikTok on selected day.', rows: this.state.tikTokTrends?.details, trendingDate: this.state.tikTokTrendingDate },
      { id: TRENDING_TOPICS_INSTAGRAM, title: 'Instagram Trends', description: 'Trending topics for Instagram on selected day.', rows: this.state.instagramTrends?.details, trendingDate: this.state.instagramTrendingDate }
    ]

    return (
      <div className="rightSide trendingComponent">
        <Container fluid={true}>
          <Row className="header calendarHeader">
            <Col>
              <ul className="hFirstRow">
                <li className="trendingImgHolder">
                  <img alt="" src="/static/images/trending_fire.png" className="trendingImg" />
                </li>
                <li>
                  <h2 className="title">Trending</h2>
                </li>
              </ul>
            </Col>
            <Col className="dateButtonCol">
              <div className="topRightActionsContainer">
                <button className="datePickerButton" onClick={this.toggleCalendar} ref={this.buttonRef}>
                  <span className="dateText">{this.formatDateForButton(this.state.selectedDay)}</span>
                  <img alt="calendar" src="/static/images/calendar_icon.png" className="calendarIcon" />
                </button>
              </div>
              {this.state.isCalendarOpen && (
                <div className="calendarPopup" ref={this.calendarRef}>
                  <DayPicker
                    className="card"
                    selectedDays={this.state.selectedDay}
                    onDayClick={this.handleDayClick}
                    initialMonth={this.state.selectedDay}
                    showOutsideDays
                    fixedWeeks
                  />
                </div>
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              <Box className="globalSearchWrapper">
                <div className="globalSearchContainer">
                  <SearchIcon className="globalSearchIcon" />
                  <input
                    type="text"
                    placeholder="Filter by keyword..."
                    className="globalSearchInput"
                    value={this.state.globalSearchText}
                    onChange={this.handleGlobalSearchChange}
                    autoComplete="off"
                  />
                </div>
              </Box>
            </Col>
          </Row>
          <Row>
            <Col>
              <Box className="calendarWrapper">
                <Grid container className="mdFlip">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container className="trendTables">
                      {TRENDING_SECTIONS.map(section =>
                        <TrendingTableComponent
                          key={section.id}
                          section={section}
                          selectedDay={this.state.selectedDay}
                          globalSearchText={this.state.globalSearchText}
                          isFetching={
                            section.id === TRENDING_TOPICS_TWITTER
                              ? this.props.twitterTrends?.isFetching ?? false
                              : section.id === TRENDING_TOPICS_YOUTUBE
                              ? this.props.youtubeTrends?.isFetching ?? false
                              : section.id === TRENDING_TOPICS_TIKTOK
                              ? this.props.tikTokTrends?.isFetching ?? false
                              : this.props.instagramTrends?.isFetching ?? false
                      }
                        />
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}